import { OptionProps } from '@mui/base';
import { MobileOpCode } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';

export const createActionSelectOptions = (translation: Translation): Array<OptionProps<null | MobileOpCode>> => [
  {
    value: MobileOpCode.AccessGranted,
    label: translation.access_granted
  },
  {
    value: MobileOpCode.AccessDenied,
    label: translation.access_denied
  }
];
